// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__PZu2Z","sendOtp":"AuthorizeToLogin_sendOtp__1ax6m"};